import BottomScrollListener from 'react-bottom-scroll-listener';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, ButtonIcon, Footer, genRuby } from '@sonyged/ext-proc';

import AppContext from '../../../AppContext';
import Constants from './Constants';
import HintModal from '../../common/HintModal';
import RadioButton from '../../common/RadioButton';

export default class AnalysisForResearchContent extends React.Component {
  static EQUALS = 0;
  static GREATER = 1;
  static LESS = 2;

  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      hintModal: false,
      retry: false,
      retryRound: 'past',
    };
  }

  render() {
    const hints = [
      'どうぶつえんは こどもが おおいよ。',
      'かいしゃの まえは おとなが おおいよ。',
      'ショッピングモールは おとなが おおいよ。',
      'こどもは バナナアイスが だいすきだよ。',
      'おとなは チョコアイスが だいすきな ひとが おおいよ。',
      'おとなは イチゴアイスが だいすきな ひとが おおいよ。',
      'バニラアイスは みんなに にんきだよ。',
      'やすみの ひは どうぶつえんに ひとが おおいよ。',
      'へいじつは かいしゃの まえに ひとが おおいよ。',
      'はれの ひは どうぶつえんに ひとが おおいよ。',
      'あめの ひは ショッピングモールに ひとが おおいよ。',
      'あつい ひは みんな アイスが たべたくなるよ。',
      'アイスを たべたい ひとは すこし たかくても かうよ。',
      'すきな アイスが うっていると すこし たかくても かうよ。',
    ];
    if (this.state.hintModal) {
      return <HintModal message={hints[Math.floor(Math.random() * hints.length)]} kind={'ice'} />;
    }

    return (
      <div className={'proc-ice-field-content analysis-for-research'}>
        <div className={'proc-contents padding'}>
          <div className={'proc-outer'}>
            <div className={'proc-inner'}>{this._renderHeader()}</div>
          </div>
          <BottomScrollListener onBottom={this._onBottom.bind(this)}>
            {scrollRef => (
              <div ref={scrollRef} className={'setting-container'}>
                <div className={'proc-outer'}>
                  <div className={'proc-inner'}>
                    {this.props.compare ? this._renderTwoContents() : this._renderContent()}
                  </div>
                </div>
              </div>
            )}
          </BottomScrollListener>
        </div>
        {this._renderFooter()}
      </div>
    );
  }

  componentDidMount() {
    this.context.soundController.sePlay('kekkagamen');
  }

  _renderHeader() {
    let iceCtx = this._getMainIceCtx();
    return (
      <div className={'header'}>
        <div className={'left'}>
          <div className={'weather secondary100-fill-color'}>{Constants.getWetherSvg(iceCtx.weather)}</div>
          <div className={'temperature secondary100-color'}>
            <span className={'proc-huge-font'}>{iceCtx.temperature}</span>
            <span className={'proc-medium-font'}>ど</span>
          </div>
        </div>
        <div className={'center'}>
          <img className={'image'} src={Constants.getStatusWagonIcon(this.props.wagon)} />
        </div>
        <div className={'right'} />
      </div>
    );
  }

  _renderNextButton() {
    return <Button.attention onClick={this.props.onNextClick}>つぎへ</Button.attention>;
  }

  _renderFooter() {
    if (this.state.retry) {
      return (
        <Footer.nav
          className="white-bg-color"
          shadow={false}
          navItem={
            <Button.normal onClick={this._onRetryCancelClick.bind(this)}>
              <ButtonIcon.back />
            </Button.normal>
          }
        >
          <Button.attention className="compare" onClick={this._onSettingClick.bind(this)}>
            この けっかと くらべる
          </Button.attention>
        </Footer.nav>
      );
    }

    if (!this.props.compare) {
      return (
        <Footer.normal className="white-bg-color">
          <Button.attention onClick={this.props.onNextClick}>つぎへ</Button.attention>
        </Footer.normal>
      );
    }

    return (
      <Footer.normal className="white-bg-color">
        <Button.normal onClick={this._onRetryClick.bind(this)}>もっと しらべる</Button.normal>
        <Button.attention onClick={this._onHintClick.bind(this)}>おわる</Button.attention>
      </Footer.normal>
    );
  }

  _renderContent() {
    return (
      <React.Fragment>
        <table className={'proc-table'}>
          <thead>
            <tr>
              <th>もらった おかね</th>
            </tr>
          </thead>
          <tbody>
            <tr>{this._renderSale(this._getMainIceCtx(), null, AnalysisForResearchContent.EQUALS)}</tr>
          </tbody>
        </table>

        <table className={'proc-table'}>
          <thead>
            <tr>
              <th>せってい</th>
            </tr>
          </thead>
          <tbody>
            <tr>{this._renderSetting(this._getMainIceCtx(), null, -1)}</tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }

  _renderTwoContents() {
    let diff = AnalysisForResearchContent.EQUALS;
    if (this._getMainIceCtx().totalSales === this._getSubIceCtx().totalSales) {
      diff = AnalysisForResearchContent.EQUALS;
    } else if (this._getMainIceCtx().totalSales < this._getSubIceCtx().totalSales) {
      diff = AnalysisForResearchContent.GREATER;
    } else {
      diff = AnalysisForResearchContent.LESS;
    }

    return (
      <React.Fragment>
        <table className={'proc-table'}>
          <thead>
            <tr>
              <th colSpan="2">もらった おかね</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {this._renderSale(this._getMainIceCtx(), 'まえ', AnalysisForResearchContent.EQUALS)}
              {this._renderSale(this._getSubIceCtx(), genRuby(' こんかい'), diff)}
            </tr>
          </tbody>
        </table>
        <table className={'proc-table'}>
          <thead>
            <tr>
              <th colSpan="2">せってい</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {this._renderSetting(this._getMainIceCtx(), 'まえ', this.props.changableSetting)}
              {this._renderSetting(this._getSubIceCtx(), 'こんかい', this.props.changableSetting)}
            </tr>
          </tbody>
        </table>
        {this.state.retry && this._renderRadioButton()}
      </React.Fragment>
    );
  }

  _renderRadioButton() {
    return (
      <RadioButton
        value={this.state.retryRound}
        values={['past', 'current']}
        onSelected={this._onRoundSelected.bind(this)}
      />
    );
  }

  _renderSale(iceCtx, title, diff) {
    return (
      <td className={'white-bg-color'}>
        {title && <div className={'title proc-small-font secondary100-color'}>{title}</div>}
        <div className={`price gray100-color proc-huge-font mb ${this._getSalesClass(diff)}`}>
          {`${iceCtx.totalSales}`}
          <span className={'price-postfix proc-small-font'}>えん</span>
          {diff === AnalysisForResearchContent.GREATER && <i className={'icon-proc-arrow-up'} />}
          {diff === AnalysisForResearchContent.LESS && <i className={'icon-proc-arrow-down'} />}
        </div>

        <div className={'title proc-small-font gray100-color'}>うれた かず</div>
        <div className={'num gray100-color proc-huge-font'}>
          {`${iceCtx.totalSalesNum}`}
          <span className={'num-postfix proc-small-font'}>こ</span>
        </div>
      </td>
    );
  }

  _getSalesClass(diff) {
    if (diff === AnalysisForResearchContent.EQUALS) {
      return 'equals';
    } else if (diff === AnalysisForResearchContent.GREATER) {
      return 'primary20-bg-color price-color';
    } else {
      return 'accent20-bg-color price-color';
    }
  }

  _renderSetting(iceCtx, title, changableSetting) {
    return (
      <td className={'white-bg-color'}>
        {title && <div className={'title proc-small-font secondary100-color'}>{title}</div>}
        <div className={`image-container ${changableSetting === 0 ? 'primary20-bg-color setting-color' : ''}`}>
          <img className={'image gray10-bg-color'} src={Constants.getPlaceIcon(iceCtx.place)} />
          <div className={'desc proc-small-font'}>{Constants.PLACE_LABELS[iceCtx.place]}</div>
        </div>
        <div className={`image-container ${changableSetting === 1 ? 'primary20-bg-color setting-color' : ''}`}>
          <img className={'image gray10-bg-color'} src={Constants.getIceImage(iceCtx.ice)} />
          <div className={'desc proc-small-font'}>{Constants.ICE_LABELS[iceCtx.ice]}</div>
        </div>
        <div className={`image-container ${changableSetting === 2 ? 'primary20-bg-color setting-color' : ''}`}>
          <div className={'image gray10-bg-color gray30-color'}>{iceCtx.price}</div>
          <div className={'desc proc-small-font'}>{iceCtx.price}</div>
        </div>
      </td>
    );
  }

  _getMainIceCtx() {
    return this.props.iceCtxs[0];
  }

  _getSubIceCtx() {
    return this.props.iceCtxs[1];
  }

  _onChangeIndex() {
    this.setState({ iceCtxIndex: this.state.iceCtxIndex === 0 ? 1 : 0 });
  }

  _onRetryClick() {
    this.setState({ retry: true });
  }

  _onRetryCancelClick() {
    this.setState({ retry: false });
  }

  _onRoundSelected(value) {
    this.setState({ retryRound: value });
  }

  _onSettingClick() {
    this.props.onNextClick(this.state.retryRound);
  }

  _onHintClick() {
    this.setState({ hintModal: true });
  }

  _onBottom() {
    //TODO
  }
}

AnalysisForResearchContent.propTypes = {
  wagon: PropTypes.number,
  iceCtxs: PropTypes.array,
  compare: PropTypes.bool,
  changableSetting: PropTypes.number,
  title: PropTypes.string,
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func,
};
